module.exports = __webpack_public_path__ + "static/logo-9699d93a29ffe5490ec769736c297a2a.svg";